<template>
  <div class="promopanel">
    <CommonHead></CommonHead>
    <b-modal
      id="cart_notificaion"
      ref="cartmodal"
      :title="this.cartOrderMsg"
      title-tag="h3"
      ok-only
      modal-class="common_pop cart_notificaion"
    ></b-modal>
    <b-modal
      id="totalwidth_notificaion"
      ref="totalwidthmodal"
      title=""
      title-tag="p"
      ok-only
      modal-class="common_pop cart_notificaion"
    >
      <p>This fabric is too wide to be quoted using this configurator. You will need to contact Customer Service to complete this quote. <br/><br/>Please call 1-800-325-8025 or email<br/>customcreations@rmcoco.com</p>
      <b-button class="btn btn btn-dark btn-secondary pl-5 pr-5 mt-5" @click="hideModal()">OK</b-button>
    </b-modal>
    <div class="container">
      <div class="promopage">
        <a @click="togglepromo" class="ordershow" href="javascript:;"
          >Summary<b-img
            class="plusfil"
            src="/shop/images/add.svg"
            alt="add"
          ></b-img
          ><b-img
            class="minusfil"
            src="/shop/images/minus.svg"
            alt="minus"
          ></b-img
        ></a>
        <div class="leftpromo">
          <h1>Summary</h1>
          <div class="promodata">
            <transition name="slide-fade">
              <div class="commondata-div firstset" v-show="pattern">
                <h3>Pattern:</h3>
                <p>{{ pattern }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div firstset" v-show="color">
                <h3>Color:</h3>
                <p>{{ color }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div">
                <h3>Pleat Style:</h3>
                <p v-show="displayPleat"><span>Style:</span><span>{{ displayPleat }}</span></p>
                <p v-show="displayPin"><span>Pin Setting:</span><span>{{ displayPin }}</span></p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div firstset" v-show="panelOrPair">
                <h3>Panel or Pair:</h3>
                <p>{{ panelOrPair }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div">
                <h3>Measurements:</h3>
                <p v-show="finishedWidth"><span>Finished Width (in):</span><span>{{ finishedWidth }}</span></p>
                <p v-show="finishedLength"><span>Finished Length (in):</span><span>{{ finishedLength }}</span></p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div" v-show="lining">
                <h3>Lining:</h3>
                <p v-show="selectedLining"><span>Lining:</span><span>{{ selectedLining }}</span></p>
                <p v-show="interliningColor"><span>Interlining:</span><span>{{ interliningColor }}</span></p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div" v-show="trimming.vertical.included || trimming.horizontal.included">
                <h3>Trimming:</h3>
                <p v-show="trimming.vertical.pattern"><span>Vertical Trimming:</span><span>{{ trimming.vertical.pattern }} {{ trimming.vertical.color }}</span></p>
                <p v-show="trimming.horizontal.pattern"><span>Horizontal Trimming:</span><span>{{ trimming.horizontal.pattern }} {{ trimming.horizontal.color }}</span></p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div firstset" v-show="draperyLabel">
                <h3>Sidemark:</h3>
                <p>{{ draperyLabel }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div firstset" v-show="customernotes">
                <h3>Notes:</h3>
                <p>{{ customernotes }}</p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div" v-show="baseCost">
                <h3 class="font-weight-bold">Suggested Retail Charges</h3>
                <p v-show="baseCost"><span>Base Price (D1):</span><span>${{ (baseCost).toFixed(2) }}</span></p>
                <p v-show="d3Cost > 0"><span>Fabric Type Surcharge:</span><span>${{ (d3Cost).toFixed(2) }}</span></p>
                <p v-show="liningCost"><span>Lining Surcharge:</span><span>${{ (liningCost).toFixed(2) }}</span></p>
                <p v-show="interliningCost"><span>Interlining Surcharge:</span><span>${{ (interliningCost).toFixed(2) }}</span></p>
                <p v-show="blackoutCost"><span>Blackout Surcharge:</span><span>${{ (blackoutCost).toFixed(2) }}</span></p>
                <p v-show="blackoutguardCost"><span>BlackoutGuard&trade; Surcharge:</span><span>${{ (blackoutguardCost).toFixed(2) }}</span></p>
                <p v-show="pleatCost"><span>Pleat Style Surcharge:</span><span>${{ (pleatCost).toFixed(2) }}</span></p>
                <p v-show="trimming.total.surcharge"><span>Trim Surcharge:</span><span>${{ (trimming.total.surcharge).toFixed(2) }}</span></p>
                <p v-show="trimming.total.trimcost"><span>Trim Cost:</span><span>${{ (trimming.total.trimcost).toFixed(2) }}</span></p>
              </div>
            </transition>
            <transition name="slide-fade">
              <div class="commondata-div lastpricediv" v-show="unitCost > 0">
                <p class="font-weight-bold text-left">
                  <span>Suggested Retail (ea): </span><span> ${{ (unitCost * 2).toFixed(2) }}</span>
                </p>
                <p class="font-weight-bold text-left">
                  <span>Wholesale (ea): </span><span> ${{ unitCost }}</span>
                </p>
              </div>
            </transition>
            <div
              class="quantity-div"
              v-show="unitCost > 0"
            >
              <span>Quantity:</span>
              <div class="samediv quantity">
                <div class="qtydiv">
                  <span @click="decrement">-</span>
                  <input
                    type="number"
                    :value="quantity"
                    @change="update"
                    step="1"
                  />

                  <span @click="increment" class="lastspan">+</span>
                </div>
              </div>
            </div>
            <h3 v-show="unitCost > 0">
              Subtotal: <span>${{ (unitCost * quantity).toFixed(2) }}</span>
            </h3>
            <h4 class="mt-4" v-show="COMyardage > 0">
              Total yards needed: {{(COMyardage * quantity).toFixed(2)}}
            </h4>
            <h4 class="mt-4" v-show="trimming.vertical.yardageRequired > 0">
              Total trim yards needed: {{(trimming.vertical.yardageRequired * quantity).toFixed(2)}}
            </h4>
            <div class="promo-btns">
              <b-button
                type="submit"
                class="AddTOCartBtn"
                :disabled="!canSave"
                variant="dark"
                @click="addtocartpleated">
                {{ this.$route.query.hasOwnProperty('cart') ? "Update Cart" : "Add to cart"}}
              </b-button>
              <b-button
                :disabled="!canSave"
                @click="saveToProject"
                variant="outline-primary"
              >
                <b-img
                  class="saveproject"
                  src="/shop/images/bookmark.svg"
                  fluid
                  alt="save image"
                ></b-img>
                <b-img
                  class="saveproject white"
                  src="/shop/images/bookmark-white.svg"
                  fluid
                  alt="save image"
                ></b-img
                >{{
                  this.$route.params.id
                    ? "Update Project Item"
                    : "Save to Projects"
                }}
              </b-button>
              <b-button
                :disabled="!canSave"
                @click="printQuote"
                class="printQuoteModelBtn"
                variant="outline-primary"
              >Print Quote</b-button>
            </div>
            <div class="mt-5"><h3>Having issues with the page?<br/>Email <a href="mailto:websupport@rmcoco.com?subject=Pleated Drapery">websupport@rmcoco.com</a></h3></div>
          </div>
        </div>
        <div class="rightpromo">
          <h1>Pleated Drapery Configurator</h1>
          <b-form class="commonform">
            <div class="availabledata">
              <ul class="avail_data">
                <li>
                  <a href="javascript:;"
                    ><span>COM</span>
                    <v-select
                      :options="optcom"
                      label="text"
                      :reduce="(optcom) => optcom.value"
                      :clearable="false"
                      :searchable="false"
                      @input="COMchange()"
                      v-model="COM"
                      placeholder="Please Select COM"
                    ></v-select>
                  </a>
                  <div class="singlefieldbox" v-if="!COM">
                    <a href="javascript:;"
                      ><span>Pattern</span>
                      <select-2 id="patterndrop" url="/shop/api/product-patterns/fabric?type=pleated" v-model="pattern" @input="loadPColors()"></select-2>
                    </a>
                    <a href="javascript:;"
                      ><span>Color</span>
                      <select-2 id="colorsdrop" :url="patternColorDropdownUrl" v-model="color"  @input="loadFabricData()" ref="formColorsdrop"></select-2>
                    </a>
                    <a href="javascript:;"
                      ><span>Fabric Width (in)</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model.number="fabricWidth"
                          name="fabricWidth"
                          @input="fabricwidthchange"
                          :disabled="!COM"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Fabric Repeat</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model.number="repeat"
                          name="repeat"
                          @input="update"
                          :disabled="!COM"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Price Code</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model.number="priceCode"
                          name="priceCode"
                          @input="update"
                          disabled
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;">
                      <span>Is the fabric type casement, velvet or light controlling?</span>
                      <md-field>
                        <md-radio @change="update" v-model="fabric_type" value="Yes" class="md-radio-override" disabled><p>Yes</p></md-radio>
                        <md-radio @change="update" v-model="fabric_type" value="No" class="md-radio-override" disabled><p>No</p></md-radio>
                      </md-field>
                    </a>
                  </div>
                  <div class="singlefieldbox" v-if="COM">
                    <a href="javascript:;"
                      ><span>Pattern</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="pattern"
                          name="pattern"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Color</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="color"
                          name="color"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Source</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="source"
                          name="source"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Fabric Width (in)</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model.number="fabricWidth"
                          name="fabricWidth"
                          @input="fabricwidthchange"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Fabric Repeat</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model.number="repeat"
                          name="repeat"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;"
                      ><span>Declared Value ($/yd)</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model.number="declared_value"
                          name="declared_value"
                          step=".01"
                          @input="onlyForCurrency"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;">
                      <span>Is the fabric type casement, velvet or light controlling?</span>
                      <md-field>
                        <md-radio @change="update" v-model="fabric_type" value="Yes" class="md-radio-override"><p>Yes</p></md-radio>
                        <md-radio @change="update" v-model="fabric_type" value="No" class="md-radio-override"><p>No</p></md-radio>
                      </md-field>
                    </a>
                    <p class="validmsg">If fabric received differs from what is specified, additional charges may apply.</p>
                  </div>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 1 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divpleatstyle }" v-b-toggle.pleat-style
                    >Pleat Style<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="pleat-style" v-model="divpleatstyle" class="singlefieldbox">
                    <a href="javascript:;"
                      ><span>Style</span>
                      <v-select
                        :options="pleatType"
                        label="style"
                        :reduce="(pleatType) => pleatType.id"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="selectedPleat"
                        placeholder="Please Select Style"
                      ></v-select>
                    </a>
                    <a href="javascript:;"
                      ><span>Pin Setting</span>
                      <v-select
                        :options="pinSetting"
                        label="style"
                        :reduce="(pinSetting) => pinSetting.id"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="selectedPin"
                        placeholder="Please Select Pin Setting"
                      ></v-select>
                    </a>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 1 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divpoptype }" v-b-toggle.pop-type
                    >Panel or Pair<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="pop-type" v-model="divpoptype" class="singlefieldbox">
                    <a href="javascript:;"
                    ><span>Panel or Pair</span>
                    <v-select
                      :options="optpnlopr"
                      label="text"
                      :reduce="(optpnlopr) => optpnlopr.value"
                      :clearable="false"
                      :searchable="false"
                      @input="update()"
                      v-model="panelOrPair"
                      placeholder="Please Select Panel Or Pair"
                    ></v-select>
                  </a>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divmeasurements }" v-b-toggle.measurements
                    >Measurements<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="measurements" v-model="divmeasurements">
                    <div class="measurement-div">
                      <div class="length-div">
                        <span>Rod Width (in): </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model.number="rodWidth"
                            min="0"
                            @input="update"
                            name="rodWidth"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Left Return (in): </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model.number="leftReturn"
                            @input="update"
                            name="leftReturn"
                            min="0"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Right Return (in): </span>
                        <md-field>
                          <md-input
                            type="number"
                            v-model.number="rightReturn"
                            @input="update"
                            name="rightReturn"
                            min="0"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Overlap (in): </span>
                        <md-field>
                          <md-input
                            type="number"
                            @input="update"
                            v-model.number="overlap"
                            :disabled="disableOverlapInput"
                            name="overlap"
                            min="0"
                          ></md-input>
                        </md-field>
                      </div>
                      <div class="length-div">
                        <span>Finished Width (in): </span>
                        <md-field>
                          <input
                            type="number"
                            v-model.number="finishedWidth"
                            name="finishedWidth"
                            disabled="disabled"
                          />
                        </md-field>
                      </div>
                      <div class="length-div-select">
                        <span>Fullness: </span>
                        <md-field>
                          <v-select
                            :options="fullnessOptions"
                            :clearable="false"
                            :searchable="false"
                            @input="update()"
                            v-model="fullness"
                            placeholder="Please Select Fullness"
                          ></v-select>
                        </md-field>
                        <p class="validmsg">{{fullnessMessage}}</p>
                      </div>
                      <div class="length-div">
                        <span>Total Widths: </span>
                        <md-field>
                          <input
                            type="number"
                            v-model.number="totalWidths"
                            name="totalWidths"
                            disabled="disabled"
                          />
                        </md-field>
                        <p class="validmsg" v-show="panelOrPair == 'Pair' && totalWidths > 10">For pairs greater than 10 widths, please contact customer service.</p>
                        <p class="validmsg" v-show="panelOrPair == 'Panel' && totalWidths > 5">For panels greater than 5 widths, please contact customer service.</p>
                      </div>
                      <div class="length-div">
                        <span>Finished Length (in): </span>
                        <md-field>
                          <input
                            type="number"
                            v-model.number="finishedLength"
                            max="180"
                            name="finishedLength"
                            @input="update"
                          />
                        </md-field>
                        <p class="validmsg" v-if="FLZ > 0">Please specify a finished length that is an increment of .125".</p>
                      </div>
                      <div class="length-div">
                        <span>Yards Required: </span>
                        <md-field>
                          <input
                            type="number"
                            v-model.number="COMyardage"
                            name="COMyardage"
                            disabled="disabled"
                          />
                        </md-field>
                        <p class="validmsg" v-show="COM == false && (instockYd < (COMyardage * quantity))">Please be advised that we do not currently have enough inventory in stock to produce your item(s). We will contact the mill and update you with a lead time as soon as possible. Thank you.</p>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divlining }" v-b-toggle.lining
                    >Lining<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="lining" v-model="divlining" class="singlefieldbox">
                    <a href="javascript:;"
                      ><span>Lining</span>
                      <v-select
                        :options="optlining"
                        label="text"
                        :reduce="(optlining) => optlining.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="lining"
                        placeholder="Please Select Lining"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="lining"
                      ><span>Type of Lining</span>
                      <v-select
                        :options="liningType"
                        label="type"
                        :reduce="(liningType) => liningType.type"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="selectedLining"
                        placeholder="Please Select Type of Lining"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="lining"
                      ><span>Lining Color</span>
                      <v-select
                        :options="optliningColor"
                        label="text"
                        :reduce="(optliningColor) => optliningColor.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="liningColor"
                        placeholder="Please Select Lining Color"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="lining && ['RM Designer 3 Pass Non-FR Outblack', 'RM Designer Lite Tech Blackout', 'RM Designer Flametrol 3 Pass FR Blackout'].includes(selectedLining)">
                      <span>BlackoutGuard&trade;</span>
                      <v-select
                        :options="optinterlining"
                        label="text"
                        :reduce="(optinterlining) => optinterlining.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="blackoutguard"
                        placeholder="Please Select RM Designer Interlining"
                      ></v-select>
                    </a>
                    <p v-if="lining && ['RM Designer 3 Pass Non-FR Outblack', 'RM Designer Lite Tech Blackout', 'RM Designer Flametrol 3 Pass FR Blackout'].includes(selectedLining)" class="validmsg font-weight-bold"><em>**BlackoutGuard&trade; is highly recommended for blackout lined drapery with lighter color face fabric. <a href="/wp-content/uploads/2026/09/BlackoutGuard-Sell-Sheet.pdf" target="_blank">View More Information</a></em></p>
                    <a href="javascript:;" v-if="lining"
                      ><span>RM Designer Interlining</span>
                      <v-select
                        :options="optinterlining"
                        label="text"
                        :reduce="(optinterlining) => optinterlining.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="interlining"
                        placeholder="Please Select RM Designer Interlining"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="lining && interlining"
                      ><span>Interlining Color</span>
                      <v-select
                        :options="optinterliningColor"
                        label="text"
                        :reduce="(optinterliningColor) => optinterliningColor.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="interliningColor"
                        placeholder="Please Select Interlining Color"
                      ></v-select>
                    </a>
                    <p v-if="lining" class="validmsg font-weight-bold"><em>**Additional linings are available upon request. Please be advised that additional charges may apply. Specify request in the notes field below.</em></p>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divtrimming }" v-b-toggle.trimming
                    >Trimming<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="trimming" v-model="divtrimming" class="singlefieldbox">
                    <a href="javascript:;"
                      ><span>Vertical Trimming</span>
                      <v-select
                        :options="optVTIncluded"
                        label="text"
                        :reduce="(optVTIncluded) => optVTIncluded.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.vertical.included"
                        placeholder="Please Select Vertical Trimming"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included"
                      ><span>COM</span>
                      <v-select
                        :options="optcom"
                        label="text"
                        :reduce="(optcom) => optcom.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.vertical.COM"
                        placeholder="Please Select COM"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included && !trimming.vertical.COM"
                      ><span>Pattern</span>
                      <select-2 url="/shop/api/product-patterns/trim" v-model="trimming.vertical.pattern"  @input="loadVerticalPColors()"></select-2>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included && trimming.vertical.COM"
                      ><span>Pattern</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="trimming.vertical.pattern"
                          name="verticalpattern"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included && !trimming.vertical.COM"
                      ><span>Color</span>
                      <select-2 :url="VerticalpatternColorDropdownUrl" v-model="trimming.vertical.color" @input="loadTrimData('verti')" ref="formvertiColorsdrop"></select-2>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included && trimming.vertical.COM"
                      ><span>Color</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="trimming.vertical.color"
                          name="verticalcolor"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <!-- <a href="javascript:;" v-if="trimming.vertical.included && !trimming.vertical.COM"
                      ><span>Price / yd</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model="trimming.vertical.price"
                          name="verticalprice"
                          @input="update"
                          :disabled="!trimming.vertical.COM"
                        ></md-input>
                      </md-field>
                    </a> -->
                    <a href="javascript:;" v-if="trimming.vertical.included && trimming.vertical.COM"
                      ><span>Source</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="trimming.vertical.source"
                          name="verticalsource"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included"
                      ><span>Vertical Trim Placement</span>
                      <v-select
                        :options="optVTPlacement"
                        label="text"
                        :reduce="(optVTPlacement) => optVTPlacement.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.vertical.trimplacement"
                        placeholder="Please Select Vertical Trim Placement"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included"
                      ><span>Yardage required</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model="trimming.vertical.yardageRequired"
                          name="verticalyardageRequired"
                          @input="update"
                          disabled="disabled"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;" v-if="trimming.vertical.included"
                      ><span>Trim Position</span>
                      <v-select
                        :options="optVTPosition"
                        label="text"
                        :reduce="(optVTPosition) => optVTPosition.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.vertical.trimposition"
                        placeholder="Please Select Trim Position"
                      ></v-select>
                    </a>
                    <br />
                    <br />
                    <a href="javascript:;"
                      ><span>Horizontal Trimming</span>
                      <v-select
                        :options="optHTIncluded"
                        label="text"
                        :reduce="(optHTIncluded) => optHTIncluded.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.horizontal.included"
                        placeholder="Please Select Horizontal Trimming"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included"
                      ><span>COM</span>
                      <v-select
                        :options="optcom"
                        label="text"
                        :reduce="(optcom) => optcom.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.horizontal.COM"
                        placeholder="Please Select COM"
                      ></v-select>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included && !trimming.horizontal.COM"
                      ><span>Pattern</span>
                      <select-2 url="/shop/api/product-patterns/trim" v-model="trimming.horizontal.pattern"  @input="loadHorizontalPColors()"></select-2>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included && trimming.horizontal.COM"
                      ><span>Pattern</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="trimming.horizontal.pattern"
                          name="horizontalpattern"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included && !trimming.horizontal.COM"
                      ><span>Color</span>
                      <select-2 :url="HoripatternColorDropdownUrl" v-model="trimming.horizontal.color"  @input="loadTrimData('hori')" ref="formhoriColorsdrop"></select-2>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included && trimming.horizontal.COM"
                      ><span>Color</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="trimming.horizontal.color"
                          name="horizontalcolor"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <!-- <a href="javascript:;" v-if="trimming.horizontal.included && !trimming.horizontal.COM"
                      ><span>Price / yd</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model="trimming.horizontal.price"
                          name="horizontalprice"
                          @input="update"
                          :disabled="!trimming.horizontal.COM"
                        ></md-input>
                      </md-field>
                    </a> -->
                    <a href="javascript:;" v-if="trimming.horizontal.included && trimming.horizontal.COM"
                      ><span>Source</span>
                      <md-field>
                        <md-input
                          type="text"
                          v-model="trimming.horizontal.source"
                          name="horizontalsource"
                          @input="update"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included"
                      ><span>Yardage required</span>
                      <md-field>
                        <md-input
                          type="number"
                          v-model="trimming.horizontal.yardageRequired"
                          name="horizontalyardageRequired"
                          @input="update"
                          disabled="disabled"
                        ></md-input>
                      </md-field>
                    </a>
                    <a href="javascript:;" v-if="trimming.horizontal.included"
                      ><span>Trim Position</span>
                      <v-select
                        :options="optHTPosition"
                        label="text"
                        :reduce="(optHTPosition) => optHTPosition.value"
                        :clearable="false"
                        :searchable="false"
                        @input="update()"
                        v-model="trimming.horizontal.trimposition"
                        placeholder="Please Select Trim Position"
                      ></v-select>
                    </a>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divlinenotes }" v-b-toggle.linenotes
                    >Sidemark<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="linenotes" v-model="divlinenotes">
                    <div class="measurement-div">
                      <div class="length-div linediv">
                        <span>Sidemark: </span>
                        <md-field class="notesfieldbox">
                          <md-input
                            type="text"
                            v-model="draperyLabel"
                            name="draperyLabel"
                            @input="update"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li v-bind:class="{ 'not-available': currentStep < 2 }">
                  <a href="javascript:;" v-bind:class="{ 'font-weight-bold': divcustomernotes }" v-b-toggle.customernotes
                    >Notes<b-img
                      class="addicon"
                      src="/shop/images/add.svg"
                      fluid
                      alt="add image"
                    ></b-img
                    ><b-img
                      class="minusicon"
                      src="/shop/images/minus.svg"
                      fluid
                      alt="minus image"
                    ></b-img
                  ></a>
                  <b-collapse id="customernotes" v-model="divcustomernotes">
                    <div class="measurement-div">
                      <div class="length-div linediv">
                        <span>Notes: </span>
                        <md-field class="notesfieldbox">
                          <md-input
                            type="text"
                            v-model="customernotes"
                            name="customernotes"
                            @input="update"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-collapse>
                </li>
                <li>
                  <div>
                    <div class="measurement-div altop">
                      <div class="length-div linediv mb-3">
                        <p><b>COM Instructions</b></p>
                      </div>
                      <div class="length-div linediv mb-3">
                        <p>Label your "customer's own material" fabrics with your <b>business name</b>, <b>account number</b>, and <b>sidemark</b>.<br/>Please also label your fabrics <b>face</b> and <b>top</b>.</p>
                      </div>
                      <div class="length-div-30">
                        <p>Ship your COM fabrics to:</p>
                      </div>
                      <div class="length-div-70">
                        <p>Custom Creations by RM COCO<br/>
                        1389 Southern Expressway<br/>
                        Cape Girardeau, MO 63703</p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-form>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
    <ProjectModal ref="project" />
    <b-modal
      id="printquote"
      ref="printquotemodal"
      title="Price to Display on Quote"
      title-tag="h3"
      ok-only
      modal-class="common_pop printquote"
    >
    <div class="radio-options">
      <md-field>
      <ul>
        <li><md-radio v-model="printquotetype" value="wholesale">Wholesale</md-radio></li>
        <li><md-radio v-model="printquotetype" value="markup"><div><md-input v-model="pqmarkupnum" type="number"></md-input><span class="md-suffix">% markup</span></div></md-radio></li>
      </ul>
      </md-field>
      <a @click="printQuoteGen" class="btn btn-dark btn-block">Print</a>
    </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ProjectModal from "@/views/ProjectModal/ProjectModal.vue";
import vSelect from "vue-select";
import Select2 from './Select2.vue';
import "vue-select/dist/vue-select.css";

export default {
  components: {
    CommonHead,
    CommonFoot,
    ProjectModal,
    Select2,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters(["pleated","user"]),
  },
  mounted() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  data() {
    return {
      pattern: '',
      color: '',
      source: "",
      fabricWidth: 54,
      repeat: 0,
      repeatSurcharge: 0,
      instockYd: 0,
      priceCode: 5,
      fabricPrice: 0,
      declared_value: "",
      fabric_type: "",
      pricePoint: 0,
      panelOrPair: "Pair",
      quantity: 1,
      rodWidth: 50,
      leftReturn: 0,
      rightReturn: 0,
      overlap: 0,
      COM: false,
      finishedWidth: 0,
      fullness: null,
      fullnessOptions: [1.5, 2, 2.25, 2.5, 3],
      fullnessMessage: "",
      totalWidths: 0,
      finishedLength: "",
      FLZ:0,
      cutLength: 0,
      headingSize: null,
      rodPocketSize: null,
      lining: false,
      liningType: [
        { type: "COCO Weather Guard" },
        { type: "RM Designer Royal Satin" },
        { type: "RM Designer Thermafoam" },
        { type: "RM Designer Everyday Lining" },
        { type: "RM Designer Super Sateen" },
        { type: "RM Designer 3 Pass Non-FR Outblack" },
        { type: "RM Designer Lite Tech Blackout" },
        { type: "RM Designer Flametrol 3 Pass FR Blackout" },
        { type: "RM Designer Deluxe Cotton Sateen" },
        { type: "RM Designer Deluxe Cotton FR Sateen" },
        { type: "RM Designer Recycled Royal Satin" },
        { type: "RM Designer Napped Sateen" },        
      ],
      selectedLining: "",
      liningColor: null,
      interlining: false,
      interliningColor: null,
      blackoutguard: false,
      blackoutguardCost: 0,
      liningCost: 0,
      interliningCost: 0,
      blackout: false,
      blackoutCost: 0,
      draperyLabel: "",
      customernotes:"",
      pinSetting: "",
      COMyardage: 0,
      fabricNeededForRepeat: 0,
      baseCost: 0,
      d3Cost: 0,
      totalLength: 0,
      pleatType: [
        { style: "1 Prong Pinch Pleat", id: "1PN" },
        { style: "2 Prong Pinch Pleat", id: "2PB" },
        { style: "3 Prong Pinch Pleat", id: "3PB" },
        { style: "2 Prong Tacked-at-Top", id: "2PT" },
        { style: "3 Prong Tacked-at-Top", id: "3PT" },
        { style: "Reverse", id: "REV" },
        { style: "Soft Goblet Pleat", id: "GOB" },
        { style: "Cartridge", id: "CAR" },
        { style: "Box Pleat", id: "BXP" },
        { style: "Inverted Pleat", id: "INV" },
      ],
      selectedPleat: "",
      displayPleat: "",
      pleatMessage: "",
      pleatCost: 0,
      pinSetting: [
        { style: "Wood Pole or Cafe Rings (0.25 in)", id: "0.25" },
        { style: "Decorative Rods (0.5 in)", id: "0.5" },
        { style: "Brass Rods (0.75 in)", id: "0.75" },
        { style: "Valances and Side Panels (1 in)", id: "1" },
        { style: "All Under Draperies (1.25 in)", id: "1.25" },
        { style: "Ceiling Mount (1.5 in)", id: "1.5" },
        { style: "Regular Wall Mount Traverse Rods (1.75 in)", id: "1.75" },
        { style: "Top of Pin to Top of Drape (0 in)", id: "0" },
        { style: "No Pins", id: "No Pins" },
      ],
      selectedPin: "",
      displayPin: "",
      trimming: {
        horizontal: {
          included: false,
          COM: false,
          pattern: "",
          price: "",
          source: "",
          labor: 0,
          yardageRequired: 0,
          trimposition: "",
          cost: 0,
          total: 0,
        },
        vertical: {
          included: false,
          COM: false,
          pattern: "",
          price: "",
          source: "",
          labor: 0,
          trimplacement : "",
          yardageRequired: 0,
          trimposition: "",
          cost: 0,
          total: 0,
        },
        total: {
          cost: 0,
          surcharge:0,
          trimcost:0,
        },
      },
      unitCost: 0,
      optcom:[
        { value: true, text: "Yes"},
        { value: false, text: "No"},
      ],
      optpnlopr:[
        { value: "Panel", text: "Panel"},
        { value: "Pair", text: "Pair"},
      ],
      optlining:[
        { value: false, text: "Unlined"},
        { value: true, text: "Lined"},
      ],
      optliningColor:[
        { value: "White", text: "White"},
        { value: "Ivory", text: "Ivory"},
      ],
      optinterlining:[
        { value: false, text: "No"},
        { value: true, text: "Yes"},
      ],
      optinterliningColor:[
        { value: "White", text: "White"},
        { value: "Ivory", text: "Ivory"},
      ],
      optVTIncluded:[
        { value: false, text: "No"},
        { value: true, text: "Yes"},
      ],
      optHTIncluded:[
        { value: false, text: "No"},
        { value: true, text: "Yes"},
      ],
      optVTPosition:[
        { value: "At leading edge", text: "At leading edge"},
        { value: "Inset 1\" from leading edge", text: "Inset 1\" from leading edge"},
        { value: "Inset 1.5\" from leading edge", text: "Inset 1.5\" from leading edge"},
        { value: "Inset 2\" from leading edge", text: "Inset 2\" from leading edge"},
      ],
      optHTPosition:[
        { value: "At bottom hem", text: "At bottom hem"},
        { value: "2\" above hem", text: "2\" above hem"},
        { value: "3\" above hem", text: "3\" above hem"},
        { value: "4\" above hem", text: "4\" above hem"},
      ],
      optVTPlacement:[],
      //remove from below
      cartform: new Form({
        itemid: "",
        inventcolorid: "",
        pc_type: "CDIP",
        unitid: "",
        order_type: "CDI",
        quantity: 1,
        discountedprice: 0,
        notes: "",
        user_id: "",
        cdi_id: "",
      }),
      divpoptype:false,
      divpleatstyle:false,
      divmeasurements:false,
      divlining:false,
      divtrimming:false,
      divlinenotes:false,
      divcustomernotes: false,
      cartOrderMsg: "",
      currentStep: 0,
      rawCalculation: 0,
      rawDiscount:0,
      rawDiscountedAmount: 0,
      canSave: false,
      disableOverlapInput:false,
      patternColorDropdownUrl:'/shop/api/product-colors/pleated/fabric/all',
      VerticalpatternColorDropdownUrl: '/shop/api/product-colors/trim/all',
      HoripatternColorDropdownUrl: '/shop/api/product-colors/trim/all',
      printquotetype : "wholesale",
      pqmarkupnum:0,
    };
  },
  methods: {
    loadData(id) {
      this.$store.dispatch("loadPleatedGetData", id).then((data) => {
        this.COM = Boolean(Number(data.COM));
        this.pattern = data.pattern;
        this.color = data.color;
        if(this.pattern != ''){
          $("#patterndrop").append(new Option(data.pattern, data.pattern)).trigger('change.select2');
          this.loadPColors();
          if(this.color != ''){
            setTimeout(() => {
              $("#colorsdrop").append(new Option(data.color, data.color)).trigger('change.select2');
            }, 500);
          }
        }
        this.fabricWidth = data.fabric_width;
        this.repeat = data.fabric_repeat;
        this.priceCode = data.pricecode;
        this.source = data.source;
        this.declared_value = data.declared_value;
        this.fabric_type = data.fabric_type;
        this.panelOrPair = data.panelorpair;
        this.selectedPleat = data.style;
        this.selectedPin = data.pinsetting;
        this.rodWidth = data.rod_width;
        this.leftReturn = data.left_return;
        this.rightReturn = data.right_return;
        this.overlap = data.overlap;
        this.finishedWidth = data.finish_width;
        this.fullness = data.fullness;
        this.totalWidths = data.total_widths;
        this.finishedLength = data.finish_length;
        this.totalLength = data.total_length;
        this.COMyardage = data.COM_yardage;
        this.lining = Boolean(Number(data.lining));
        this.liningColor = data.lining_color;
        this.selectedLining = data.lining_type;
        this.interlining = Boolean(Number(data.interlining));
        this.interliningColor = data.interlining_color;
        this.blackoutguard = Boolean(Number(data.blackoutguard));
        this.trimming.vertical.included = Boolean(Number(data.vertical_trimming));
        this.trimming.vertical.COM = Boolean(Number(data.vertical_trimming_COM));
        this.trimming.vertical.pattern = data.vertical_trimming_pattern;
        this.trimming.vertical.color = data.vertical_trimming_color;
        this.trimming.vertical.source = data.vertical_trimming_source;
        this.trimming.vertical.price = data.vertical_trimming_price_yd;
        this.trimming.vertical.trimplacement = data.vertical_trimming_placement;
        this.trimming.vertical.yardageRequired = data.vertical_trimming_yardare_required;
        this.trimming.vertical.trimposition = data.vertical_trimming_trimposition;
        if(this.trimming.vertical.pattern != ''){
          this.loadVerticalPColors();
        }
        this.trimming.horizontal.included = Boolean(Number(data.horizontal_trimming));
        this.trimming.horizontal.COM = Boolean(Number(data.horizontal_trimming_COM));
        this.trimming.horizontal.pattern = data.horizontal_trimming_pattern;
        this.trimming.horizontal.color = data.horizontal_trimming_color;
        this.trimming.horizontal.source = data.horizontal_trimming_source;
        this.trimming.horizontal.price = data.horizontal_trimming_price_yd;
        this.trimming.horizontal.yardageRequired = data.horizontal_trimming_yardare_required;
        this.trimming.horizontal.trimposition = data.horizontal_trimming_trimposition;
        if(this.trimming.horizontal.pattern != ''){
          this.loadHorizontalPColors();
        }
        this.draperyLabel =  data.notes;
        this.customernotes = data.customernotes;
        this.quantity = data.quantity;
        this.rawDiscount = data.discount;
        if(this.COM !== true){
          this.loadFabricData();
        }
      })
      .catch((e) => {
        //console.log(e);
      });
    },
    loadFabricData(){
      this.$store.dispatch("loadFabricData", {
            pattern: this.pattern,
            color: this.color
        }).then(result => {
          this.fabricWidth = result.WIDTH;
          this.repeat = result.REPEAT;
          this.priceCode = result.PRICECODE;
          this.instockYd = result.YARDS;
          this.rawDiscount = parseFloat(result.DISCOUNT);
          this.fabric_type = result.FABRIC_TYPE;
      })
    },
    loadTrimData(type){
      let patternTxt = '';
      let colorTxt = '';
      if(type == 'verti'){
        patternTxt = this.trimming.vertical.pattern;
        colorTxt = this.trimming.vertical.color;
      }
      if(type == 'hori'){
        patternTxt = this.trimming.horizontal.pattern;
        colorTxt = this.trimming.horizontal.color;
      }
      this.$store.dispatch("loadTrimData", {
            pattern: patternTxt,
            color: colorTxt
        }).then(result => {
          if(type == 'verti'){
            this.trimming.vertical.price = result.PRICE;
          }
          if(type == 'hori'){
            this.trimming.horizontal.price = result.PRICE;
          }
      })
    },
    fabricwidthchange(){
      if(this.COM === true &&  this.fabricWidth > 60){
        this.$refs["totalwidthmodal"].show();
        this.fabricWidth = "";
      }
      this.update();
    },
    update() {
      this.setCurrentStep(0);
      if((this.pattern && this.color && this.COM == false) || (this.COM == true)){
        this.setCurrentStep(1);
      }
      if(this.selectedPleat != '' & this.selectedPin != ''){
        this.setCurrentStep(2);
      }
      // UI updates and resets
      if (this.selectedPleat == "1PN") {
        this.fullnessOptions = [1.5, 2];
        if(this.fullness == 1.5){
          this.fullnessMessage = "";
        }else{
          this.fullnessMessage = "The recommended fullness for 1 Prong Pinch Pleat is 1.5";
        }
      } else if (this.selectedPleat == "2PB" || this.selectedPleat == "2PT") {
        this.fullnessOptions = [2, 2.25, 2.5];
        if(this.fullness == 2.25){
          this.fullnessMessage = "";
        }else{
          this.fullnessMessage = "The recommended fullness for 2 Prong Pleats is 2.25";
        }
      } else if (this.selectedPleat == "BXP" || this.selectedPleat == "INV") {
        this.fullnessOptions = [2.5, 3];
        if(this.fullness >= 2.5){
          this.fullnessMessage = "";
        }else{
          this.fullnessMessage = "Minimum fullness required is 2.5";
        }
      } else if(this.selectedPleat == "3PB" && this.interlining == true) {
        this.fullnessOptions = [2.5, 3];
        this.fullnessMessage = "";
      } else {
        this.fullnessOptions = [2, 2.25, 2.5, 3];
        this.pleatMessage = "";
        if (this.selectedPleat == "3PB" || this.selectedPleat == "3PT" || this.selectedPleat == "REV" || this.selectedPleat == "CAR") {
          this.fullnessMessage = "2.5x fullness is recommended";
        }else{
          this.fullnessMessage = "";
        }
      }
      if (this.lining == false) {
        this.selectedLining = "";
        this.liningColor = "";
      }

      let excludeLining = ['RM Designer 3 Pass Non-FR Outblack', 'RM Designer Lite Tech Blackout', 'RM Designer Flametrol 3 Pass FR Blackout'];

      if(!excludeLining.includes(this.selectedLining)){
        this.blackoutguard = false;
        this.blackoutguardCost = 0;
      }
      
      if (this.interlining == false) {
        this.interliningColor = "";
      }
      if (this.trimming.horizontal.included == false) {
        this.trimming.horizontal.pattern = "";
        this.trimming.horizontal.color = "";
      }
      if (this.trimming.vertical.included == false) {
        this.trimming.vertical.pattern = "";
        this.trimming.vertical.color = "";
      }
      if (this.selectedPleat != "") {
        this.displayPleat = this.pleatType.find(
          (obj2) => obj2.id == this.selectedPleat
        ).style;
      }
      if (this.selectedPin != "") {
        this.displayPin = this.pinSetting.find(
          (obj) => obj.id == this.selectedPin
        ).style;
      }
      if(this.panelOrPair == 'Panel'){
        this.overlap = 0;
        this.disableOverlapInput = true;
        this.optVTPlacement = [
          { value: "Trim on Left Edge", text: "Trim on Left Edge"},
          { value: "Trim on Right Edge", text: "Trim on Right Edge"},
          { value: "Trim on Both Sides", text: "Trim on Both Sides"},
        ];
      }else{
        this.optVTPlacement = [
          { value: "Trim on Leading Edges", text: "Trim on Leading Edges"},
          { value: "Trim on all sides", text: "Trim on all sides"},
        ];
        this.disableOverlapInput = false;
      }

      if(this.COM === true && (this.fabricWidth == "" || this.fabricWidth > 60)){
        this.canSave = false;
        return false;
      }

      //send the entire object to masterFunction
      //var result = masterFunction(this.$data);
      this.$store.dispatch("masterFunction", this.$data).then(result => {
        //map result data back to vue object
        this.finishedWidth = result.finishedWidth;
        this.totalWidths = result.totalWidths;
        this.cutLength = result.cutLength;
        this.fabricNeededForRepeat = result.fabricNeededForRepeat;
        this.totalLength = result.totalLength;
        this.COMyardage = result.COMyardage;
        this.pricePoint = result.pricePoint;
        this.baseCost = result.D1;
        this.d3Cost = result.d3Surcharge;
        this.liningCost = result.liningCost;
        this.interliningCost = result.interliningCost;
        this.blackoutguardCost = result.blackoutguardCost;
        this.blackoutCost = result.blackoutCost;
        this.pleatCost = result.pleatCost;
        this.trimming.vertical.yardageRequired = result.trimming.vertical.yardageRequired;
        this.trimming.vertical.labor = result.trimming.vertical.labor;
        this.trimming.vertical.cost = result.trimming.vertical.cost;
        this.trimming.vertical.total = result.trimming.vertical.total;
        this.trimming.horizontal.yardageRequired = result.trimming.horizontal.yardageRequired;
        this.trimming.horizontal.labor = result.trimming.horizontal.labor;
        this.trimming.horizontal.cost = result.trimming.horizontal.cost;
        this.trimming.horizontal.total = result.trimming.horizontal.total;
        this.trimming.total.surcharge = result.trimming.total.surcharge;
        this.trimming.total.trimcost = result.trimming.total.trimcost;
        this.trimming.total.cost = result.trimming.total.cost;
        this.unitCost = (result.unitCost / 2).toFixed(2);
        let discounted = (parseFloat(result.unitCost) * this.rawDiscount) / 100;
        this.rawDiscountedAmount = parseFloat(result.unitCost) - parseFloat(discounted);
        //Finished Length
        this.FLZ = Math.ceil(this.finishedLength % 0.125);
        if((this.panelOrPair == 'Panel' && this.totalWidths > 5) || (this.panelOrPair == 'Pair' && this.totalWidths > 10)){
          this.canSave = false;
        }else{
          if (this.COM == true && this.unitCost > 0 && this.pattern && this.color && this.currentStep > 1 && this.source && this.fabricWidth && this.repeat && this.fabric_type && this.FLZ == 0){
            this.canSave = true;
          }else if(this.unitCost > 0 && this.pattern && this.color && this.currentStep > 1 && this.FLZ == 0){
            this.canSave = true;
          }else{
            this.canSave = false;
          }
        }
      }); 
    },
    togglepromo() {
      $(".leftpromo").toggle();
      $(".ordershow").toggleClass("minusshow");
    },
    onChangeQTY() {
      if (parseInt(this.quantity) <= 0) {
        this.quantity = parseInt(1);
      }
    },
    decrement() {
      if (this.quantity > 1) this.quantity = parseInt(this.quantity) - 1;
      this.update();
    },
    increment() {
      this.quantity = parseInt(this.quantity) + 1;
      this.update();
    },
    setCurrentStep(step) {
      this.currentStep = step;
    },
    loadPColors(){
      if(this.pattern != ''){
          this.patternColorDropdownUrl="/shop/api/product-colors/pleated/fabric/"+this.pattern;
      }else{
          this.patternColorDropdownUrl="/shop/api/product-colors/pleated/fabric/all";
      }
      this.update();
    },
    loadVerticalPColors(){
      if(this.trimming.vertical.pattern != ''){
          this.VerticalpatternColorDropdownUrl="/shop/api/product-colors/trim/"+this.trimming.vertical.pattern;
      }else{
          this.VerticalpatternColorDropdownUrl="/shop/api/product-colors/trim/all";
      }
      this.update();
    },
    loadHorizontalPColors(){
      if(this.trimming.horizontal.pattern != ''){
          this.HoripatternColorDropdownUrl="/shop/api/product-colors/trim/"+this.trimming.horizontal.pattern;
      }else{
          this.HoripatternColorDropdownUrl="/shop/api/product-colors/trim/all";
      }
      this.update();
    },
    COMchange(){
      this.pattern = "";
      this.color = "";
      this.fabric_type = "";
      this.declared_value = "";
      this.instockYd = 0;
      if(this.COM == true){
        this.instockYd = 100000;
      }
      this.update();
    },
    addtocartpleated(){
      let err = '';
      if(this.COM == false && this.pattern == ''){
        err += '1';
        $(".select2-container .select2-selection--single").css("border-color","#F00");
      }else{
        $(".select2-container .select2-selection--single").removeAttr("style");
      }
      if(err == ''){
        if (this.$route.params.id) {
          this.saveData(true).then((data) => {
            this.updateCart(data).then((rsdata) => {
              this.$notify({
                text: "Pleated program update successfully",
                type: "success",
              });
              this.$router.push({ name: "cart" });
            });
          })
          .catch((error) => {
            console.log(error);
          });
          return;
        }
        //save and add to cart
        this.$store
        .dispatch("loadCart", this.user.accountnumber)
        .then((minicart) => {
          var submit = 1;
          if (minicart.data.ITEMS.length > 0) {
            if (!(minicart.data.ITEMS[0].PC_TYPE == "CDI" || minicart.data.ITEMS[0].PC_TYPE == "CDIQ" || minicart.data.ITEMS[0].PC_TYPE == "CDIP")) {
              if (minicart.data.ITEMS[0].PC_TYPE != this.cartform.pc_type) {
                this.cartOrderMsg = `${this.cartform.pc_type == "CDIP" ? "Pleated Drapery" : this.cartform.pc_type} orders cannot be placed with ${minicart.data.ITEMS[0].COLORWORKS == "1" ? 'Colorworks' : minicart.data.ITEMS[0].PC_TYPE} orders. Please finish placing your ${minicart.data.ITEMS[0].COLORWORKS == "1" ? 'Colorworks' : minicart.data.ITEMS[0].PC_TYPE} order and then place your ${this.cartform.pc_type == "CDIP" ? "Pleated Drapery" : this.cartform.pc_type} order separately.`
                submit = 0;
                this.$refs["cartmodal"].show();
                return false;
              }
            }
          }
          if (submit == 1) {
            this.saveData().then((data) => {
              if(this.COM == true){
                this.cartform.itemid = "COM";
                this.cartform.inventcolorid = "";
              }else{
                this.cartform.itemid = data.ITEMID;
                this.cartform.inventcolorid = data.INVENTCOLORID;
                this.cartform.discountedprice = this.rawDiscountedAmount;
              }
              this.cartform.user_id = this.user.accountnumber;
              this.cartform.cdi_id = data.id;
              this.cartform.quantity = data.quantity;
              this.$store
                .dispatch("AddtoCart", {
                  form: this.cartform,
                })
                .then((rsdata) => {
                  if (rsdata.data.success == false) {
                    this.cartOrderMsg = rsdata.data.message;
                    this.$refs["cartmodal"].show();
                  } else {
                    this.$notify({
                      text: "Pleated program added to cart",
                      type: "success",
                    });
                    this.isLoading = true;
                    this.$store
                      .dispatch("loadCart", this.user.accountnumber)
                      .finally(() => {
                        this.isLoading = false;
                      });
                  }
                })
                .catch((error) => {
                  if (this.cartform.hasErrors()) {
                    this.$notify({
                      text:
                        "There is a validation error. Please correct the fields outlined in red and try again.",
                      type: "error",
                    });
                  } else {
                    this.$notify({
                      text: "Something went wrong!",
                      type: "error",
                    });
                  }
                });
            });
          }
        });
      }
    },
    saveData(updateProject = false) {
      return new Promise((resolve, reject) => {
        if (!this.draperyLabel.length) {
          this.$notify({
            text: "Please enter Sidemark",
            type: "error",
          });
          reject("INVALID_LINE_NOTE");
          return;
        }
        if(this.lining){
          if(this.selectedLining == ""){
            this.$notify({
              text: "Please select Lining Type",
              type: "error",
            });
            reject("INVALID_LINING");
            return;
          }
          if(this.liningColor == ""){
            this.$notify({
              text: "Please select Lining Color.",
              type: "error",
            });
            reject("INVALID_LINING");
            return;
          }
        }
        if(this.finishedLength == ""){
            this.$notify({
              text: "Please select Finished Length.",
              type: "error",
            });
            reject("INVALID_FINISHEDLENGTH");
            return;
        }
        this.$store
          .dispatch(updateProject ? "UpdatePleatedData" : "AddPleatedData", {
            COM: this.COM,
            pattern: this.pattern,
            color: this.color,
            fabric_width: this.fabricWidth,
            fabric_repeat: this.repeat,
            pricecode: this.priceCode,
            source: this.source,
            declared_value: this.declared_value,
            fabric_type: this.fabric_type,
            panelorpair: this.panelOrPair,
            style: this.selectedPleat,
            pinsetting: this.selectedPin,
            rod_width: this.rodWidth,
            left_return: this.leftReturn,
            right_return: this.rightReturn,
            overlap: this.overlap,
            finish_width: this.finishedWidth,
            fullness: this.fullness,
            total_widths: this.totalWidths,
            finish_length: this.finishedLength,
            total_length: this.totalLength,
            COM_yardage: this.COMyardage,
            lining: this.lining,
            lining_type: this.selectedLining,
            lining_color: this.liningColor,
            interlining: this.interlining,
            interlining_color: this.interliningColor,
            blackoutguard: this.blackoutguard,
            vertical_trimming: this.trimming.vertical.included,
            vertical_trimming_COM: this.trimming.vertical.COM,
            vertical_trimming_pattern: this.trimming.vertical.pattern,
            vertical_trimming_color: this.trimming.vertical.color,
            vertical_trimming_source: this.trimming.vertical.source,
            vertical_trimming_price_yd: this.trimming.vertical.price,
            vertical_trimming_placement: this.trimming.vertical.trimplacement,
            vertical_trimming_yardare_required: this.trimming.vertical.yardageRequired,
            vertical_trimming_trimposition: this.trimming.vertical.trimposition,
            horizontal_trimming: this.trimming.horizontal.included,
            horizontal_trimming_COM: this.trimming.horizontal.COM,
            horizontal_trimming_pattern: this.trimming.horizontal.pattern,
            horizontal_trimming_color: this.trimming.horizontal.color,
            horizontal_trimming_source: this.trimming.horizontal.source,
            horizontal_trimming_price_yd: this.trimming.horizontal.price,
            horizontal_trimming_yardare_required: this.trimming.horizontal.yardageRequired,
            horizontal_trimming_trimposition: this.trimming.horizontal.trimposition,
            notes: this.draperyLabel,
            customernotes: this.customernotes,
            quantity: this.quantity,
            discount: this.rawDiscount,
            price: this.unitCost,
            pricebreakup:{
              BasePrice: this.baseCost,
              FabricTypeSurcharge: this.d3Cost,
              liningSurcharge: this.liningCost,
              InterliningSurcharge: this.interliningCost,
              blackoutguardSurcharge: this.blackoutguardCost,
              BlackoutSurcharge: this.blackoutCost,
              PleatStyleSurcharge: this.pleatCost,
              TrimSurcharge: this.trimming.total.surcharge,
              TrimCost: this.trimming.total.trimcost,
            },
            ...(updateProject ? { id: this.$route.params.id } : {}),
          })
          .then((data) => {
            resolve(data);
            console.log(data, "saved data");
          })
          .catch((e) => {
            console.log(e);
            reject("FAILED_TO_SAVE");
          });
      });
    },
    updateCart(data){
      return new Promise((resolve, reject) => {
        if(this.COM == true){
          this.cartform.itemid = "COM";
          this.cartform.inventcolorid = "";
        }else{
          this.cartform.itemid = data.ITEMID;
          this.cartform.inventcolorid = data.INVENTCOLORID;
          this.cartform.discountedprice = this.rawDiscountedAmount;
        }
        this.cartform.user_id = this.user.accountnumber;
        this.cartform.cdi_id = data.id;
        this.cartform.quantity = data.quantity;
        this.$store.dispatch("updateCDICart", {
          form: this.cartform,
        }).then((rsdata) => {
          resolve(rsdata);
        }).catch((e) => {
          //console.log(e);
          reject("CART_FAILED_TO_UPDATE");
        });
      });
    },
    saveToProject() {
      if (this.$route.params.id) {
        this.saveData(true)
          .then((data) => {
            this.$notify({
              text: "Pleated program update successfully",
              type: "success",
            });
          })
          .catch((error) => {
            console.log(error);
          });
        return;
      }
      this.saveData()
        .then((data) => {
          this.$refs.project.show(data.id,"1");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printQuote(){
      this.$refs["printquotemodal"].show();
    },
    printQuoteGen(){
      this.saveData().then((data) => {
          const url = '/shop/pleated-drapery-print?type='+this.printquotetype+'_'+this.pqmarkupnum+'&id='+data.id;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
      }).catch((error) => {
        console.log(error);
      });
    },
    hideModal() {
      this.$refs['totalwidthmodal'].hide()
    },
    onlyForCurrency ($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.price.indexOf('.') != -1)) { // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if(this.price!=null && this.price.indexOf(".")>-1 && (this.price.split('.')[1].length > 1)){
        $event.preventDefault();
      }
   }
  },
};
</script>
<style scoped>
.promopage .leftpromo .promodata .commondata-div.firstset h3, .promopage .leftpromo .promodata .commondata-div.secondset h3{width: 50%;}
.promopage .leftpromo .promodata .commondata-div p span{width: 50%;}
.promopage .rightpromo .availabledata ul.avail_data > li > a {
  margin-bottom: 20px;
}
.promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a {
  font-weight: 500;
  font-size: 16px;
  width: 100%;
  color: #303030;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a:hover {
  text-decoration: none;
}
.promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a > span {
  float: left;
  margin-top: 10px;
  max-width: 188px;
  width: 100%;
}
.promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a:hover {
  text-decoration: none;
}
.promopage .rightpromo .measurement-div .length-div.linediv .md-field.notesfieldbox{max-width: 80%;}
.promopage .rightpromo .availabledata ul.avail_data > li .singlefieldbox .md-field{
  min-height: 43px;
  margin: 0;
  padding-top: 0;
  max-width: 317px;
}
.promopage .rightpromo .availabledata ul.avail_data > li .md-field .md-input{
  height: 43px;
}
.promopage .rightpromo .measurement-div.altop{
  align-items: normal;
}
.promopage .rightpromo .measurement-div .length-div-30{
  width: 30%;
}
.promopage .rightpromo .measurement-div .length-div-70{
  width: 70%;
}
.promopage .rightpromo .measurement-div .length-div-select .md-field {
    display: inline-block;
    max-width: 270px;
    margin: 0;
    padding: 0;
}
.promopage .rightpromo .measurement-div .length-div-select .md-field .v-select{
  float: none;
  display: block;
  max-width: inherit;
}
.promopage .rightpromo .measurement-div .length-div-select .md-field .v-select span{
  font-size: 14px;
  color: #777;
}
@media only screen and (max-width: 1440px) {
  .promopage .rightpromo .measurement-div .length-div-select .md-field{max-width: 230px;}
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .promopage .rightpromo .availabledata ul.avail_data > li > a > span{max-width: 188px;}
  .promopage .rightpromo .v-select{max-width: 317px;}
  .promopage .rightpromo .measurement-div .length-div-select .md-field{max-width: 200px;}
  .promopage .rightpromo .measurement-div .length-div.linediv .md-field.notesfieldbox{max-width: 100%;}
}
@media only screen and (max-width: 767px) {
  .promopage .rightpromo .v-select{max-width: 100%;}
  .promopage .rightpromo .availabledata ul.avail_data > li > a > span{margin: auto;}
  .promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a{flex-wrap: wrap;font-size: 14px;max-width: 100%;}
  .promopage .rightpromo .measurement-div .length-div span, .promopage .rightpromo .measurement-div .length-div-select span{font-size: 14px;}
  .promopage .rightpromo .measurement-div .length-div-select .md-field{max-width: 100%;}
  .promopage .rightpromo .availabledata ul.avail_data > li .singlefieldbox .md-field{max-width: 100%;}
  .promopage .rightpromo .measurement-div .length-div.linediv .md-field.notesfieldbox{max-width: 100%;}
}
</style>
<style>
#printquote .radio-options .md-radio .md-radio-container{
  border: 1px solid #d2d2d2;
}
#printquote .radio-options .md-radio.md-checked .md-radio-container, 
#printquote .radio-options .md-radio .md-radio-container:hover {
  border: 1px solid #303030;
}
#printquote .radio-options .md-radio.md-checked .md-radio-container:after{
  background: #303030;
}
#printquote .radio-options .md-radio .md-radio-label{
  font-size: 14px;
}
#printquote .radio-options .md-radio .md-radio-label > div{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: -5px;
}
#printquote .radio-options .md-radio .md-radio-label > div .md-input{
  width: 50px;
  font-size: 14px;
  background: #fff;
  text-align: center;
  border: 2px solid #d3d3d3;
}
#printquote .radio-options .md-radio .md-radio-label > div .md-suffix{
  font-size: 14px;
  padding: 0 5px;
}
.promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a > span.select2{
  max-width: 317px;
}
@media only screen and (max-width: 767px) {
 .promopage .rightpromo .availabledata ul.avail_data > li > .singlefieldbox > a > span.select2{
    max-width: 100%;
  } 
}
</style>